import _ from 'lodash';
import { getEventTypeByGroupAction } from '@/shared/lib/aiUtils';
import type { IEvent } from '@/shared/model';
import { shouldApplyGroupChange } from './filterSnapshotUtils';

// TODO(ts): typed as the group-event-change payload once Apollo domains land
type GroupEventChange = any;

/**
 * Rewrites in-memory events so they reflect pending bulk group changes. Indexes the changes by group event type and, for each event whose oldType matches and which passes the group-change guard, assigns the mapped target type, backfills oldType, and sets isReviewed for the markedAsReviewed and markedAsUnreviewed actions.
 *
 * @param events - Events to mutate in place; defaults to an empty list.
 * @param groupEventChanges - Pending group changes to apply; defaults to an empty list.
 * @returns Nothing.
 */
export const applyGroupEventChange = (
  events: IEvent[] = [],
  groupEventChanges: GroupEventChange[] = [],
) => {
  if (_.isEmpty(groupEventChanges)) {
    return;
  }
  const hashmapGroupEventChange = groupEventChanges.reduce((hashmap, item) => {
    hashmap[item.groupEventType] = item;
    return hashmap;
  }, {});
  _.forEach(events, (event) => {
    const changeEntry = hashmapGroupEventChange[event?.oldType];
    if (!changeEntry || !shouldApplyGroupChange(event, changeEntry)) {
      return;
    }
    const mappedType = getEventTypeByGroupAction(changeEntry.actionType);
    if (mappedType) {
      // `mappedType` can be TYPE_BEAT_ENUM.DELETED (action 'delete'), which isn't part of
      // IEvent['type']'s declared TYPE_RHYTHM_EVENT_ENUM | TYPE_BEAT_EVENT_ENUM union.
      // Pre-existing mismatch between the two enums, left as-is.
      event.type = mappedType as IEvent['type'];
      if (!event.oldType) {
        event.oldType = changeEntry.groupEventType;
      }
    }
    if (changeEntry.actionType === 'markedAsReviewed') {
      event.isReviewed = true;
    }
    if (changeEntry.actionType === 'markedAsUnreviewed') {
      event.isReviewed = false;
    }
  });
};
